import React from 'react';

/**
 * Pill-style status badge atom.
 * @param {'active' | 'inactive' | string} status
 */
export default function StatusBadge({ status = 'inactive', label, className = '' }) {
  const normalized = String(status).toLowerCase();
  const isActive = normalized === 'active';
  const text = label ?? (isActive ? 'Active' : 'Inactive');

  return (
    <span
      className={`ca-badge rounded ca-badge--${isActive ? 'active' : 'inactive'} ${className}`.trim()}
    >
      {text}
    </span>
  );
}
